<template>
  <div id="home">
    <div class="home-slider">
      <slider></slider>
    </div>
    <section id="nosotros" class="nosotros text-center" >
      <nosotros></nosotros>
    </section>
    <section class="text-center" >
      <CategoriasProducto></CategoriasProducto>
    </section>
    <section class="text-center" >
      <Beneficios></Beneficios>
    </section>
    <section class="iconos-home text-center" >
      <IconosHome></IconosHome>
    </section>
    <section class=" text-center" >
      <SliderClientes></SliderClientes>
    </section>
    <section id="contacto" class="contacto  text-center" >
      <h1 class="titulo-home">CONTACTO</h1>
      <div class="container">
        <div class="row ">
            <div class="col-sm-6">
              <Datoscontacto></Datoscontacto>
            
            </div>
            <div class="col-sm-6">
              <Contacto></Contacto >
            </div>
        </div>
      </div>
    </section>
    
  </div>
</template>

<script>

  import Eheader from '@/components/layout/Eheader.vue'
  import Efooter from '@/components/layout/Efooter.vue'

  import Products from '@/components/Products.vue'
  import Nosotros from '@/components/views/Nosotros.vue'
  import CategoriasProducto from '@/components/CategoriasProducto.vue'
  import Beneficios from '@/components/Beneficios.vue'
  import IconosHome from '@/components/IconosHome.vue'
  import Datoscontacto from '@/components/Datoscontacto.vue'
  import SliderClientes from '@/components/SliderClientes.vue'
  import Contacto from '@/components/Contacto.vue'

  import ProductFeatured from '@/components/ProductFeatured.vue'

  import Slider from '@/components/Slider.vue'

  import { SlideXRightTransition } from 'vue2-transitions'


  export default {
    name: 'home',
    components: {
      Eheader,
      Efooter,
      Nosotros,
      Beneficios,
      IconosHome,
      Contacto,
      SliderClientes,
      Datoscontacto,
      CategoriasProducto,
      SlideXRightTransition,
      Slider,
      ProductFeatured,
      Products
    },
    data() {
      return {
        data: {
          cat: null
        },
        loading: false
      }
    },
    created() {
      this.$store.state.filterCat = null
    },
    mounted() {
    },
  }
</script>

